import React, { useState, useCallback } from 'react'
import { Box, Button, Flex, InjectedModalProps, LinkExternal, Message, TooltipText, InfoIcon, Text, useTooltip,Skeleton, AutoRenewIcon, Spinner, HelpIcon } from '@pancakeswap/uikit'
import { useWeb3React } from '@web3-react/core/core/core'
import { getaceAddress, getataliraAddress, getbabyvizslaAddress, getbtntyAddress, getbuildAddress,getFarm2Address, getBusdAddress, getbvcAddress, getCakeAddress, getetcAddress, getethAddress, getexzoAddress, getfpsAddress, getHVIAddress, getLAMEAAddress, getlgcAddress, getliraAddress, getltcAddress, gettripAddress, getWbnbAddress, getbabyAddress, getFarm1Address, getFarm3Address, getFarm4Address, getFarm5Address, getFarm6Address, getFarm7Address, getFarm8Address, getFarm9Address, getFarm10Address, getFarm11Address, getFarm12Address, getFarm13Address, getFarm14Address, getFarm15Address, getFarm16Address, getFarm17Address, getFarm18Address, getFarm19Address, getFarm20Address, getFarm21Address, getFarm22Address, getFarm23Address, getFarm24Address, getFarm25Address, getFarm26Address, getFarm27Address } from 'utils/addressHelpers'
import useTokenBalance, { useTotalSupply, useVizslaLPBalance, useGetBnbBalance, useHVILPBalance ,useTotalSupplyVIZSLAHVI, useFarm1,useFarm23, useFarm24, useTotalSupplyFarm24, useFarm22,useTotalSupplyFarm1 ,useTotalSupplyFarm23,useTotalSupplyFarm22, useMaster1 , useFarm2 ,useFarm3,useFarm4, useTotalSupplyFarm2, useTotalSupplyFarm3, useTotalSupplyFarm4, useFarm5, useTotalSupplyFarm5, useFarm6 , useTotalSupplyFarm6 , useFarm7 , useTotalSupplyFarm7 , useFarm8, useTotalSupplyFarm8, useFarm9, useTotalSupplyFarm9 , useFarm10, useTotalSupplyFarm10 , useFarm11, useTotalSupplyFarm11, useFarm12, useFarm13, useFarm14, useFarm15, useFarm16, useFarm17, useFarm18, useFarm19, useFarm20, useFarm21, useTotalSupplyFarm12, useTotalSupplyFarm13, useTotalSupplyFarm14,useTotalSupplyFarm15, useTotalSupplyFarm16, useTotalSupplyFarm17, useTotalSupplyFarm18, useTotalSupplyFarm19, useTotalSupplyFarm20,useTotalSupplyFarm21, useFarm25, useTotalSupplyFarm25, useFarm26, useTotalSupplyFarm26, useFarm27, useTotalSupplyFarm27 } from 'hooks/useTokenBalance'
import useAuth from 'hooks/useAuth'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { getBscScanLink } from 'utils'
import useToast from 'hooks/useToast'
import { updateUserStakedBalance } from 'state/pools'
import { getBalanceNumber, getFullDisplayBalance , getFullDisplayBalance2} from 'utils/formatBalance'
import { useMasterchef } from 'hooks/useContract'
import { harvestFarm } from 'utils/calls'
import Balance from 'components/Balance'
import BigNumber from 'bignumber.js/bignumber'
import useFarmsWithBalance from 'views/Home/hooks/useFarmsWithBalance'
import { usePriceAceBusd, usePriceATALIRABusd, useFarmUser, usePriceBABYVIZSLABusd, usePriceBnbBusd, usePriceBtntyBusd, usePricebuildBusd, usePriceBVCBusd, usePriceCakeBusd, usePriceETCBusd, usePriceETHBusd, usePriceEXZOBusd, usePriceFpsBusd, usePriceHVIBusd , usePriceLameaBusd, usePriceLGCBusd, usePriceliraBusd, usePriceLTCBusd, usePricetripBusd, usePricebabyBusd, usePriceskeletonBusd} from 'state/farms/hooks'
import CopyAddress from './CopyAddress'


interface WalletInfoProps {
  hasLowBnbBalance: boolean
  hasLowGodBalance1X: boolean
  hasLowGodBalance2X: boolean
  hasLowGodBalance3X: boolean
  hasLowGodBalance4X: boolean
  hasLowGodBalance5X: boolean
  hasLowGodBalance6X: boolean
  hasLowGodBalance7X: boolean
  hasLowGodBalance8X: boolean
  hasLowGodBalance9X: boolean
  hasLowGodBalance10X: boolean
  hasLowGodBalance11X: boolean
  hasLowGodBalance12X: boolean
  hasLowGodBalance13X: boolean
  hasLowGodBalance14X: boolean
  hasLowGodBalance15X: boolean 
  hasLowGodBalance16X: boolean
  hasLowGodBalance17X: boolean
  hasLowGodBalance18X: boolean
  hasLowGodBalance19X: boolean
  hasLowGodBalance20X: boolean
  hasLowGodBalance22X: boolean
  hasLowGodBalance23X: boolean
  hasLowGodBalance24X: boolean
  hasLowGodBalance25X: boolean
  hasLowGodBalance26X: boolean
  hasLowGodBalance27X: boolean

  onDismiss: InjectedModalProps['onDismiss']
}

const WalletInfo: React.FC<WalletInfoProps> = ({hasLowBnbBalance,hasLowGodBalance1X,hasLowGodBalance10X,hasLowGodBalance25X,hasLowGodBalance26X, hasLowGodBalance27X, hasLowGodBalance19X,hasLowGodBalance23X,hasLowGodBalance24X, hasLowGodBalance22X,hasLowGodBalance20X, hasLowGodBalance18X , hasLowGodBalance11X ,hasLowGodBalance16X, hasLowGodBalance17X,hasLowGodBalance12X, hasLowGodBalance13X, hasLowGodBalance14X, hasLowGodBalance15X, hasLowGodBalance7X,hasLowGodBalance8X, hasLowGodBalance9X,  hasLowGodBalance2X, hasLowGodBalance3X,hasLowGodBalance4X, hasLowGodBalance5X, hasLowGodBalance6X,  onDismiss }) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const [pendingTx, setPendingTx] = useState(false)
  const { toastSuccess, toastError } = useToast()
  const { balance } = useGetBnbBalance()
  const { balance: cakeBalance1X } = useTokenBalance(getFarm2Address())
  const { balance: cakeBalance2X } = useTokenBalance(getFarm1Address())
  const { balance: cakeBalance3X } = useTokenBalance(getFarm3Address())
  const { balance: cakeBalance4X } = useTokenBalance(getFarm4Address())
  const { balance: cakeBalance5X } = useTokenBalance(getFarm5Address())
  const { balance: cakeBalance6X } = useTokenBalance(getFarm6Address())
  const { balance: cakeBalance7X } = useTokenBalance(getFarm7Address())
  const { balance: cakeBalance8X } = useTokenBalance(getFarm8Address())
  const { balance: cakeBalance9X } = useTokenBalance(getFarm9Address())
  const { balance: cakeBalance10X } = useTokenBalance(getFarm10Address())
  const { balance: cakeBalance11X } = useTokenBalance(getFarm11Address())
  const { balance: cakeBalance12X } = useTokenBalance(getFarm12Address())
  const { balance: cakeBalance13X } = useTokenBalance(getFarm13Address())
  const { balance: cakeBalance14X } = useTokenBalance(getFarm14Address())
  const { balance: cakeBalance15X } = useTokenBalance(getFarm15Address())
  const { balance: cakeBalance16X } = useTokenBalance(getFarm16Address())
  const { balance: cakeBalance17X } = useTokenBalance(getFarm17Address())
  const { balance: cakeBalance18X } = useTokenBalance(getFarm18Address())
  const { balance: cakeBalance19X } = useTokenBalance(getFarm19Address())
  const { balance: cakeBalance20X } = useTokenBalance(getFarm20Address())
  const { balance: cakeBalance22X } = useTokenBalance(getFarm22Address())
  const { balance: cakeBalance23X } = useTokenBalance(getFarm23Address())
  const { balance: cakeBalance24X } = useTokenBalance(getFarm24Address())
  const { balance: cakeBalance25X } = useTokenBalance(getFarm25Address())
  const { balance: cakeBalance26X } = useTokenBalance(getFarm26Address())
  const { balance: cakeBalance27X } = useTokenBalance(getFarm27Address())

  const price0 = usePriceCakeBusd()
  const price = price0.toNumber()
  const hviprice0 = usePriceHVIBusd()
  const hviprice = hviprice0.toNumber()
  const { logout } = useAuth()
  const { farmsWithStakedBalance, earningsSum: farmEarningsSum } = useFarmsWithBalance()
  const bnbprice0 = usePriceBnbBusd()
  const bnbprice = bnbprice0.toNumber()
  const lameaprice0 = usePriceLameaBusd()
  const lameaprice = lameaprice0.toNumber()
  const bvcprice0 = usePriceBVCBusd()
  const bvcprice = bvcprice0.toNumber()
  const babyvizslaprice0 = usePriceBABYVIZSLABusd()
  const babyvizslaprice = babyvizslaprice0.toNumber()
  const skeletonprice0 = usePriceskeletonBusd()
  const skeletonprice = skeletonprice0.toNumber()
  const buildprice0 = usePricebuildBusd()
  const buildprice = buildprice0.toNumber()
  const fpsprice0 = usePriceFpsBusd()
  const fpsprice = fpsprice0.toNumber()
  const ethereumprice0 = usePriceETHBusd()
  const ehereumprice = ethereumprice0.toNumber() 
  const ataliraprice0 = usePriceATALIRABusd()
  const ataliraprice = ataliraprice0.toNumber()
  const exzoprice0 = usePriceEXZOBusd()
  const exzoprice = exzoprice0.toNumber()
  const tripprice0 = usePricetripBusd()
  const tripprice = tripprice0.toNumber()
  const liraprice0 = usePriceliraBusd()
  const liraprice = liraprice0.toNumber()
  const lgcprice0 = usePriceLGCBusd()
  const lgcprice = lgcprice0.toNumber()
  const babyprice0 = usePricebabyBusd()
  const babyprice = babyprice0.toNumber()
  const { targetRef, tooltip, tooltipVisible } = useTooltip(t('You can view just active VizslaSwap LP Tokens in your wallet.'), {
    placement: 'bottom',
  })
// farm2
  const vizslalpbalance2 = getBalanceNumber(useFarm2(getCakeAddress()))
  const bnblpbalance2 = getBalanceNumber(useFarm2(getWbnbAddress()))

  const kombo3 = useTotalSupplyFarm2()
  const kombo4 = kombo3 ? getBalanceNumber(kombo3) : 0

  const teljes4 = price * vizslalpbalance2 
  const teljes5 = bnbprice * bnblpbalance2
  const teljes6 = teljes4 + teljes5
  const minden1 = teljes6 / kombo4
  const farm2 = cakeBalance1X.times(minden1)
// farm 1
  const vizslalpbalance = getBalanceNumber(useFarm1(getCakeAddress()))
  const bnblpbalance = getBalanceNumber(useFarm1(getWbnbAddress()))

  const kombo5 = useTotalSupplyFarm1()
  const kombo6 = kombo5 ? getBalanceNumber(kombo5) : 0

  const teljes7 = price * vizslalpbalance 
  const teljes8 = bnbprice * bnblpbalance
  const teljes9 = teljes7 + teljes8
  const minden2 = teljes9 / kombo6
  const farm1 = cakeBalance2X.times(minden2)
// farm 3
const vizslalpbalance3 = getBalanceNumber(useFarm3(getCakeAddress()))
const busdlpbalance = getBalanceNumber(useFarm3(getBusdAddress()))

const kombo7 = useTotalSupplyFarm3()
const kombo8 = kombo7 ? getBalanceNumber(kombo7) : 0

const teljes10 = price * vizslalpbalance3 
const teljes11 = 1 * busdlpbalance
const teljes12 = teljes10 + teljes11
const minden3 = teljes12 / kombo8
const farm3 = cakeBalance3X.times(minden3)
// farm 4
const vizslalpbalance4 = getBalanceNumber(useFarm4(getCakeAddress()))
const busdlpbalance3 = getBalanceNumber(useFarm4(getBusdAddress()))

const kombo9 = useTotalSupplyFarm4()
const kombo10 = kombo9 ? getBalanceNumber(kombo9) : 0

const teljes13 = price * vizslalpbalance4 
const teljes14 = 1 * busdlpbalance3
const teljes15 = teljes13 + teljes14
const minden4 = teljes15 / kombo10
const farm4 = cakeBalance4X.times(minden4)
// farm 5
const hvilp = getBalanceNumber(useFarm5(getHVIAddress()))
const bnblpbalance3 = getBalanceNumber(useFarm5(getWbnbAddress()))

const kombo11 = useTotalSupplyFarm5()
const kombo12 = kombo11 ? getBalanceNumber(kombo11) : 0

const teljes16 = hviprice * hvilp 
const teljes17 = bnbprice * bnblpbalance3
const teljes18 = teljes16 + teljes17
const minden5 = teljes18 / kombo12
const farm5 = cakeBalance5X.times(minden5)
// farm 6
const hvilp2 = getBalanceNumber(useFarm6(getHVIAddress()))
const busdlpbalance4 = getBalanceNumber(useFarm6(getBusdAddress()))

const kombo13 = useTotalSupplyFarm6()
const kombo14 = kombo13 ? getBalanceNumber(kombo13) : 0

const teljes19 = hviprice * hvilp2
const teljes20 = 1 * busdlpbalance4
const telejs21 = teljes19 + teljes20
const minden6 = telejs21 / kombo14
const farm6 = cakeBalance6X.times(minden6)
// farm 7
const hvilp3 = getBalanceNumber(useFarm7(getHVIAddress()))
const vizslalpbalance5 = getBalanceNumber(useFarm7(getCakeAddress()))

const kombo15 = useTotalSupplyFarm7()
const kombo16 = kombo15 ? getBalanceNumber(kombo15) : 0

const teljes22 = hviprice * hvilp3
const teljes23 = price * vizslalpbalance5
const teljes24 = teljes22 + teljes23
const minden7 = teljes24 / kombo16
const farm7 = cakeBalance7X.times(minden7)
// farm 8
const lamealp = getBalanceNumber(useFarm8(getLAMEAAddress()))
const vizslalpbalance6 = getBalanceNumber(useFarm8(getCakeAddress()))

const kombo17 = useTotalSupplyFarm8()
const kombo18 = kombo17 ? getBalanceNumber(kombo17) : 0

const teljes25 = lameaprice * lamealp
const teljes26 = price * vizslalpbalance6
const teljes27 = teljes25 + teljes26
const minden8 = teljes27 / kombo18
const farm8 = cakeBalance8X.times(minden8)
// farm 9
const bvclp = getBalanceNumber(useFarm9(getbvcAddress()))
const vizslalpbalance7 = getBalanceNumber(useFarm9(getCakeAddress()))

const kombo19 = useTotalSupplyFarm9()
const kombo20 = kombo19 ? getBalanceNumber(kombo19) : 0

const teljes28 = bvcprice * bvclp
const teljes29 = price * vizslalpbalance7
const teljes30 = teljes28 + teljes29
const minden9 = teljes30 / kombo20
const farm9 = cakeBalance9X.times(minden9)
// farm 10
const babyvizslalp = getBalanceNumber(useFarm10(getbabyvizslaAddress()))
const vizslalpbalance8 = getBalanceNumber(useFarm10(getCakeAddress()))

const kombo21 = useTotalSupplyFarm10()
const kombo22 = kombo21 ? getBalanceNumber(kombo21) : 0

const teljes31 = babyvizslaprice * babyvizslalp
const teljes32 = price * vizslalpbalance8
const teljes33 = teljes31 + teljes32
const minden10 = teljes33 / kombo22
const farm10 = cakeBalance10X.times(minden10)
// farm 11
const fpslp = getBalanceNumber(useFarm11(getfpsAddress()))
const vizslalpbalance9 = getBalanceNumber(useFarm11(getCakeAddress()))

const kombo23 = useTotalSupplyFarm11()
const kombo24 = kombo23 ? getBalanceNumber(kombo23) : 0

const teljes34 = fpsprice * fpslp
const teljes35 = price * vizslalpbalance9
const teljes36 = teljes34 + teljes35
const minden11 = teljes36 / kombo24
const farm11 = cakeBalance11X.times(minden11)
// farm 12
const skeletonlp = getBalanceNumber(useFarm12(getfpsAddress()))
const vizslalpbalance10 = getBalanceNumber(useFarm12(getCakeAddress()))

const kombo25 = useTotalSupplyFarm12()
const kombo26 = kombo25 ? getBalanceNumber(kombo23) : 0

const teljes37 = skeletonprice * skeletonlp
const teljes38 = price * vizslalpbalance10
const teljes39 = teljes37 + teljes38
const minden12 = teljes39 / kombo26
const farm12 = cakeBalance12X.times(minden12)
// farm 13
const buildlp = getBalanceNumber(useFarm13(getbuildAddress()))
const vizslalpbalance11 = getBalanceNumber(useFarm13(getCakeAddress()))

const kombo27 = useTotalSupplyFarm13()
const kombo28 = kombo27 ? getBalanceNumber(kombo27) : 0

const teljes40 = buildlp * buildprice
const teljes41 = price * vizslalpbalance11
const teljes42 = teljes40 + teljes41
const minden13 = teljes42 / kombo28
const farm13 = cakeBalance13X.times(minden13)
// farm 14
const ethlp = getBalanceNumber(useFarm14(getethAddress()))
const vizslalpbalance12 = getBalanceNumber(useFarm14(getCakeAddress()))

const kombo29 = useTotalSupplyFarm14()
const kombo30 = kombo29 ? getBalanceNumber(kombo29) : 0

const teljes43 = ethlp * ehereumprice
const teljes44 = price * vizslalpbalance12
const teljes45 = teljes44 + teljes43
const minden14 = teljes45 / kombo30
const farm14 = cakeBalance14X.times(minden14)
// farm 15
const ataliralp = getBalanceNumber(useFarm15(getataliraAddress()))
const vizslalpbalance13 = getBalanceNumber(useFarm15(getCakeAddress()))

const kombo31 = useTotalSupplyFarm15()
const kombo32 = kombo31 ? getBalanceNumber(kombo31) : 0

const teljes46 = ataliralp * ataliraprice
const teljes47 = price * vizslalpbalance13
const teljes48 = teljes46 + teljes47
const minden15 = teljes48 / kombo32
const farm15 = cakeBalance15X.times(minden15)
// farm 16
const exzolp = getBalanceNumber(useFarm16(getexzoAddress()))
const vizslalpbalance14 = getBalanceNumber(useFarm16(getCakeAddress()))

const kombo33 = useTotalSupplyFarm16()
const kombo34 = kombo33 ? getBalanceNumber(kombo33) : 0

const teljes49 = exzolp * exzoprice
const teljes50 = price * vizslalpbalance14
const teljes51 = teljes49 + teljes50
const minden16 = teljes51 / kombo34
const farm16 = cakeBalance16X.times(minden16)
// farm 17
const lamealp2 = getBalanceNumber(useFarm17(getLAMEAAddress()))
const bnblpbalance4 = getBalanceNumber(useFarm17(getWbnbAddress()))

const kombo35 = useTotalSupplyFarm17()
const kombo36 = kombo35 ? getBalanceNumber(kombo35) : 0

const teljes52 = lamealp2 * lameaprice
const teljes53 = bnbprice * bnblpbalance4
const teljes54 = teljes52 + teljes53
const minden17 = teljes54 / kombo36
const farm17 = cakeBalance17X.times(minden17)
// farm 18
const bvclp2 = getBalanceNumber(useFarm18(getbvcAddress()))
const bnblpbalance5 = getBalanceNumber(useFarm18(getWbnbAddress()))

const kombo37 = useTotalSupplyFarm18()
const kombo38 = kombo37 ? getBalanceNumber(kombo37) : 0

const teljes55 = bvclp2 * bvcprice
const teljes56 = bnbprice * bnblpbalance5
const teljes57 = teljes55 + teljes56
const minden18 = teljes57 / kombo38
const farm18 = cakeBalance18X.times(minden18)
// farm 19
const babyvizslalp2 = getBalanceNumber(useFarm19(getbabyvizslaAddress()))
const bnblpbalance6 = getBalanceNumber(useFarm19(getWbnbAddress()))

const kombo39 = useTotalSupplyFarm19()
const kombo40 = kombo39 ? getBalanceNumber(kombo39) : 0

const teljes58 = babyvizslalp2 * babyvizslalp
const teljes59 = bnbprice * bnblpbalance6
const teljes60 = teljes58 + teljes59
const minden19 = teljes60 / kombo40
const farm19 = cakeBalance19X.times(minden19)
// farm 20
const triplp = getBalanceNumber(useFarm20(gettripAddress()))
const bnblpbalance7 = getBalanceNumber(useFarm20(getWbnbAddress()))

const kombo41 = useTotalSupplyFarm20()
const kombo42 = kombo41 ? getBalanceNumber(kombo41) : 0

const teljes61 = triplp * tripprice
const teljes62 = bnbprice * bnblpbalance7
const teljes63 = teljes61 + teljes62
const minden20 = teljes60 / kombo40
const farm20 = cakeBalance20X.times(minden20)
// farm 21
const liralp = getBalanceNumber(useFarm22(getliraAddress()))
const vizslalpbalance15 = getBalanceNumber(useFarm22(getCakeAddress()))

const kombo43 = useTotalSupplyFarm22()
const kombo44 = kombo43 ? getBalanceNumber(kombo43) : 0

const teljes64 = liralp * liraprice
const teljes65 = price * vizslalpbalance15
const teljes66 = teljes64 + teljes65
const minden22 = teljes66 / kombo44
const farm22 = cakeBalance22X.times(minden22)
// farm 22
const lgclp = getBalanceNumber(useFarm23(getlgcAddress()))
const vizslalpbalance16 = getBalanceNumber(useFarm23(getCakeAddress()))

const kombo45 = useTotalSupplyFarm23()
const kombo46 = kombo45 ? getBalanceNumber(kombo45) : 0

const teljes67 = lgcprice * lgclp
const teljes68 = price * vizslalpbalance16
const teljes69 = teljes67 + teljes68
const minden23 = teljes69 / kombo46
const farm23 = cakeBalance23X.times(minden23)
// farm 23
const lgclp2 = getBalanceNumber(useFarm24(getlgcAddress()))
const bnblpbalance8 = getBalanceNumber(useFarm24(getWbnbAddress()))

const kombo47 = useTotalSupplyFarm24()
const kombo48 = kombo47 ? getBalanceNumber(kombo47) : 0

const teljes70= lgcprice * lgclp2
const teljes71 = bnbprice * bnblpbalance8
const teljes72 = teljes70 + teljes71
const minden24 = teljes72 / kombo48
const farm24 = cakeBalance24X.times(minden24)

// farm 23
const lgclp3 = getBalanceNumber(useFarm25(getlgcAddress()))
const hvilp4 = getBalanceNumber(useFarm25(getHVIAddress()))

const kombo49 = useTotalSupplyFarm25()
const kombo50 = kombo49 ? getBalanceNumber(kombo49) : 0

const teljes73 = lgcprice * lgclp3
const teljes74 = hviprice * hvilp4
const teljes75 = teljes73 + teljes74
const minden25 = teljes75 / kombo50
const farm25 = cakeBalance25X.times(minden25)
// farm 24
const babylp = getBalanceNumber(useFarm26(getbabyAddress()))
const bnblpbalance9 = getBalanceNumber(useFarm26(getWbnbAddress()))

const kombo51 = useTotalSupplyFarm26()
const kombo52 = kombo51 ? getBalanceNumber(kombo51) : 0

const teljes76 = babylp * babyprice
const teljes77 = bnbprice * bnblpbalance9
const teljes78 = teljes76 + teljes77
const minden26 = teljes78 / kombo52
const farm26 = cakeBalance26X.times(minden26)
// farm 24
const babylp2 = getBalanceNumber(useFarm27(getbabyAddress()))
const vizslalpbalance17 = getBalanceNumber(useFarm27(getCakeAddress()))

const kombo53 = useTotalSupplyFarm27()
const kombo54 = kombo53 ? getBalanceNumber(kombo53) : 0

const teljes79 = babylp2 * babyprice
const teljes80 = price * vizslalpbalance17
const teljes81 = teljes79 + teljes80
const minden27 = teljes81 / kombo54
const farm27 = cakeBalance27X.times(minden27)



  const handleLogout = () => {
    onDismiss()
    logout()
  }

  return (
    <>
      <Text color="secondary" fontSize="12px" textTransform="uppercase" fontWeight="bold" mb="8px">
        {t('Your Address')}
      </Text>
      <CopyAddress account={account} mb="24px" />
      <Flex >
      <Text color="white" textAlign="left"  fontSize="15px" textTransform="uppercase" fontWeight="bold" mb="8px">
        {t('Liquidity providers (LP)')}
      </Text>  
      <Flex  ref={targetRef}>
                <HelpIcon color="textSubtle" ml="4px" mb="8px"  />
                </Flex>
              </Flex>
      {hasLowBnbBalance && (
           <Message variant="danger" mb="24px">
           <Box>
             <Text fontWeight="bold">{t('BNB Balance Low')}</Text>
             <Text as="p">{t('You need BNB for transaction fees.')}</Text>
           </Box>
         </Message>
      )}
        {hasLowGodBalance2X && !farm1.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/1.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('VIZSLASWAP-BNB')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px"  color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
          </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm1, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/1.png" alt="lp"  height="0px" width="0px" />
          ) }
      {hasLowGodBalance1X && !farm2.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/1.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('VIZSLASWAP-BNB')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(APESWAP)')}</Text>
          </Flex>
          </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm2, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/1.png" alt="router"  height="0px" width="0px" />
          ) }
     {hasLowGodBalance3X && !farm3.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/2.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('VIZSLASWAP-BUSD')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm3, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
       {hasLowGodBalance4X && !farm4.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/2.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('VIZSLASWAP-BUSD')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(RADIOSHACK)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm4, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
   {hasLowGodBalance5X && !farm5.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/3.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('HVI-BNB')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm5, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
  {hasLowGodBalance6X && !farm6.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/5.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('HVI-BUSD')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm6, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }

 {hasLowGodBalance7X && !farm7.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/36.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('VIZSLASWAP-HVI')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm7, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
 {hasLowGodBalance8X && !farm8.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/27.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('LAMEA-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm8, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
{hasLowGodBalance9X && !farm9.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/28.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('BVC-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm9, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
{hasLowGodBalance10X && !farm10.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/29.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('BABYVIZSLA-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm10, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
          {hasLowGodBalance11X && !farm11.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/30.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('FPS-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm11, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
                  {hasLowGodBalance12X && !farm12.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/31.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('SKELETON-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm12, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
                     {hasLowGodBalance13X && !farm13.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/32.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('BUILD-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm13, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
                {hasLowGodBalance14X && !farm14.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/33.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('ETH-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm14, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
      {hasLowGodBalance15X && !farm15.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/34.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('ATALIRA-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm15, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
             {hasLowGodBalance16X && !farm16.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/35.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('EXZO-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm16, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
               {hasLowGodBalance17X && !farm17.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/19.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('LAMEA-BNB')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm17, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
                   {hasLowGodBalance18X && !farm18.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/4.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('BVC-BNB')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm18, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
                    {hasLowGodBalance19X && !farm19.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/6.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('BABYVIZSLA-BNB')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm19, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
                       {hasLowGodBalance20X && !farm20.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/25.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('TRIP-BNB')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm20, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
                           {hasLowGodBalance22X && !farm22.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/38.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('LIRA-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm22, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
                            {hasLowGodBalance23X && !farm23.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/40.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('LGC-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm23, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
               {hasLowGodBalance24X && !farm24.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/39.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('LGC-BNB')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm24, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
             {hasLowGodBalance25X && !farm25.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/0.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('HVI-LGC')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm25, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
              {hasLowGodBalance26X && !farm26.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/41.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('BABY-BNB')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm26, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
              {hasLowGodBalance27X && !farm27.isNaN() ?   (
          <Flex alignItems="center" mb="8px" justifyContent="space-between">
            <Flex>
            <img src="/images/wallet/lp/42.png" alt="lp"  height="22px" width="22px" />
            <Flex>
            <Text   fontSize="14px"  ml="7px"   color="secondary">{t('BABY-VIZSLASWAP')}</Text>
          <Text   fontSize="12px" mr="30px" ml="7px" color="gold">{t('(PANCAKESWAP)')}</Text>
          </Flex>
           </Flex>
          <Text fontSize="15px">${getFullDisplayBalance(farm27, 18, 2)}</Text>
        </Flex>
        )  : (
          <img src="/images/wallet/2.png" alt="router"  height="0px" width="0px" />
          ) }
      <Button variant="secondary" width="100%" onClick={handleLogout}>
        {t('Disconnect Wallet')}
      </Button>
      {tooltipVisible && tooltip}
    </>

  )
}

export default WalletInfo
